module.exports = __webpack_public_path__ + "static/media/notificationsError.47590240.png";